exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".opacity{opacity:.2}.img-container{margin:0 auto;width:110px;height:110px;display:flex;justify-content:center;align-items:center}.btn-upload{position:absolute;bottom:-.3rem;right:-.3rem}", ""]);

// exports
